let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("46F9y")).then(() => parcelRequire('gpPTi'));